// extracted by mini-css-extract-plugin
export default {"textfield":"CommonInput_textfield__SCKYP","label":"CommonInput_label__cPRAU","passwordLabel":"CommonInput_passwordLabel__BblYa"};